import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconGearRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <g clipPath="url(#icon-gear-round-fill__a)">
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M18.008 12.004c0 .26-.017.52-.05.779l1.682 1.32a.386.386 0 0 1 .1.509l-1.602 2.77a.4.4 0 0 1-.492.184l-1.995-.802c-.413.32-.868.583-1.352.78l-.3 2.114a.39.39 0 0 1-.393.342h-3.205a.41.41 0 0 1-.4-.342L9.7 17.544a5.905 5.905 0 0 1-1.352-.78l-2 .8a.408.408 0 0 1-.492-.184l-1.603-2.77a.41.41 0 0 1 .1-.51l1.695-1.317a4.64 4.64 0 0 1 .017-1.568L4.37 9.897a.38.38 0 0 1-.1-.509l1.594-2.77a.398.398 0 0 1 .493-.184l1.995.802c.414-.318.869-.58 1.351-.78l.3-2.114A.395.395 0 0 1 10.397 4h3.21a.404.404 0 0 1 .4.342l.3 2.114c.484.2.938.461 1.352.78l1.996-.802a.408.408 0 0 1 .492.184l1.598 2.78a.41.41 0 0 1-.1.509l-1.694 1.318c.04.258.06.518.058.779Z"
        vectorEffect="non-scaling-stroke"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.956 12.783a5.9 5.9 0 0 0 .05-.78 4.827 4.827 0 0 0-.058-.778l1.694-1.318a.41.41 0 0 0 .1-.509l-1.598-2.78a.408.408 0 0 0-.492-.184l-1.995.802a5.901 5.901 0 0 0-1.35-.78l-.301-2.114A.404.404 0 0 0 13.605 4h-3.209a.395.395 0 0 0-.392.342l-.3 2.114c-.483.2-.937.462-1.352.78l-1.994-.802a.398.398 0 0 0-.492.184l-1.594 2.77a.38.38 0 0 0 .1.509l1.694 1.318a4.641 4.641 0 0 0-.016 1.568l-1.694 1.318a.41.41 0 0 0-.1.508l1.601 2.77a.407.407 0 0 0 .492.184l2-.799c.414.319.868.58 1.351.78l.3 2.114a.41.41 0 0 0 .402.342h3.204a.39.39 0 0 0 .392-.342l.3-2.114a5.725 5.725 0 0 0 1.352-.78l1.994.802a.398.398 0 0 0 .492-.184l1.602-2.77a.387.387 0 0 0-.1-.509l-1.682-1.32Zm-7.627 1.713c.494.33 1.074.508 1.669.508a3.013 3.013 0 0 0 3.006-3.007 3.005 3.005 0 1 0-4.675 2.499Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="icon-gear-round-fill__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIconGearRoundFill);
export default Memo;
